/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
import anime from "animejs/lib/anime.es.js";
import React from "react";
import ReactDOM from "react-dom";
import CardOffer from "../../components/molecules/cardsOffer/cardOffer";

let numberOfPages = -1;
let activePagination = 1;
let currentFilter = "";

const containerCupons = document.querySelector(".sc-cupons__grid");
const paginationNumbers = document.querySelector(
	".sc-cupons__pagination > .sc-pagination > .sc-pagination__container > .sc-pagination__container__pagination-numbers > #sc-pagination-numbers",
);
const goToIndexArrow = document.querySelector(
	".sc-cupons__pagination > .sc-pagination > .sc-pagination__container > .sc-pagination__container__go-to-page > .sc-pagination__container__go-to-page__input-container > .sc-pagination__container__go-to-page__input-container__prev-arrow",
);
const prevArrowNumber = document.querySelector(
	".sc-cupons__pagination > .sc-pagination > .sc-pagination__container > .sc-pagination__container__pagination-numbers >.sc-pagination__container__pagination-numbers__prev-arrow",
);
const nextArrowNumber = document.querySelector(
	".sc-cupons__pagination > .sc-pagination > .sc-pagination__container > .sc-pagination__container__pagination-numbers >.sc-pagination__container__pagination-numbers__next-arrow",
);
const goToIndexInput = document.querySelector("#goToIndex");
const loader = document.querySelector("#loading");
const paginationContainer = document.querySelector(
	".sc-cupons__pagination > .sc-pagination",
);
const categoriesSelect = document.getElementById("offersListCategoria");
const sortSelect = document.getElementById("offersListFiltro");

const searchButton = document.querySelector(
	".sc-cupons__buttons-container__button",
);

const clearFilterLink = document.querySelector(
	".sc-cupons__buttons-container__link",
);

function displayLoading() {
	loader.classList.add("display");
}

function hideLoading() {
	loader.classList.remove("display");
	loader.style.display = "none";
}

function decodeHTMLEntities(text) {
	var textArea = document.createElement("textarea");
	textArea.innerHTML = text;
	return textArea.value;
}

function getInitialCategoryFilter() {
	const params = new URLSearchParams(window.location.search);
	const categoryParam = params.get("category");

	return categoryParam ? categoryParam.trim() : "";
}

function normalizeCategoryFilter(filterValue) {
	const value = String(filterValue || "").trim();

	// offer_category expects a term id; ignore unrelated query params (utm, _gl, etc).
	return /^\d+$/.test(value) ? value : "";
}

const searchOffers = (
	searchValue,
	activePaginationIndex = 1,
	shouldScroll = false,
) => {
	const normalizedSearchValue = normalizeCategoryFilter(searchValue);
	currentFilter = normalizedSearchValue;

	displayLoading();
	let fetchedCategories = [];

	fetch(
		`${window.location.origin}/wp-json/wp/v2/offer_category?hide_empty=true`,
	)
		.then((res) => res.json())
		.then((categories) => {
			fetchedCategories = categories;

			if (categoriesSelect) {
				while (categoriesSelect.firstChild) {
					categoriesSelect.removeChild(categoriesSelect.firstChild);
				}

				categoriesSelect.insertAdjacentHTML(
					"afterbegin",
					`<option value="">Seleccione</option>`,
				);

				categories.forEach((category) => {
					categoriesSelect.insertAdjacentHTML(
						"afterbegin",
						`<option value="${category.id}"${
							normalizedSearchValue == category.id ? " selected" : ""
						}>${category.name}</option>`,
					);
				});
			}

			return fetch(
				`${window.location.origin}/wp-json/wp/v2/offer?${
					normalizedSearchValue
						? `offer_category=${normalizedSearchValue}&`
						: ``
				}per_page=12&_embed=wp:featuredmedia&page=${activePaginationIndex}&orderby=date&order=${
					sortSelect.value || "desc"
				}`,
			);
		})
		.then((result) => {
			numberOfPages = Number(result.headers.get("X-WP-TotalPages"));
			if (result.ok) {
				return result.json();
			}

			throw new Error("Something went wrong");
		})
		.then((data) => {
			if (data.length === 0) {
				containerCupons.innerHTML = "<p>No se encontraron ofertas</p>";
				if (paginationContainer) {
					paginationContainer.style.display = "none";
				}
				hideLoading();
				return;
			}

			const existingModals = document.querySelectorAll(
				'[id^="sc-card-offer__pop-up"]',
			);

			existingModals.forEach((modal) => {
				if (modal.style.display === "flex") {
					modal.style.display = "none";
				}
			});

			if (containerCupons && containerCupons.hasChildNodes()) {
				ReactDOM.unmountComponentAtNode(containerCupons);
			}

			// Renderizar las ofertas
			let toRender = data.map((offer, index) => (
				<div className="card-item" key={`${activePaginationIndex}-${index}`}>
					<CardOffer
						title={decodeHTMLEntities(offer.title.rendered)}
						desc={offer.excerpt.rendered}
						fromDate={offer.offerStartDate}
						toDate={offer.offerEndDate}
						termsAndConditions={offer.termsAndConditions}
						image={offer?._embedded?.["wp:featuredmedia"]?.[0]?.source_url}
						fromTitle={"Valido desde"}
						toTitle={"Valido hasta"}
						linkHref={offer.offerLinkHref}
						linkLabel={offer.offerLinkLabel}
						index={`${activePaginationIndex}-${index}`}
						offerCupon={offer.offerCupon}
						buttonLabel={offer.offerbuttonLabel}
						buttonLink={offer.offerbuttonLink}
					/>
				</div>
			));

			hideLoading();
			ReactDOM.render(toRender, containerCupons);

			if (numberOfPages > 0) {
				if (paginationContainer) {
					paginationContainer.style.display = "flex";
				}
				createPagination();
			} else {
				if (paginationContainer) {
					paginationContainer.style.display = "none";
				}
			}

			addListenerToOpenPopUp();
			addAnimation();

			if (containerCupons && shouldScroll) {
				let offset = 100;
				const top =
					containerCupons.getBoundingClientRect().top +
					window.pageYOffset -
					offset;

				window.scrollTo({
					top,
					behavior: "smooth",
				});
			}
		})
		.catch((error) => {
			console.error("Error al buscar las ofertas", error);
			if (paginationContainer) {
				paginationContainer.style.display = "none";
			}
			hideLoading();
		});
};

const addListenerToOpenPopUp = () => {
	const links = document.querySelectorAll(".card__offer__link");

	links.forEach((link) => {
		const newLink = link.cloneNode(true);
		link.parentNode.replaceChild(newLink, link);

		newLink.addEventListener("click", () => {
			const popUp = document.getElementById(newLink.dataset.index);
			if (!popUp) return;

			popUp.style.display = "flex";
			popUp.style.position = "fixed";
			popUp.style.zIndex = "99999";
			popUp.style.top = "0";
			popUp.style.left = "0";
			popUp.style.width = "100%";
			popUp.style.height = "100%";

			const overlay = popUp.children[0];
			const closeButton = popUp.children[1]?.children[0];
			const cuponValueContainer = popUp.querySelector(
				".sc-card-offer__pop-up__content__cupon__value",
			);
			const copyButton = cuponValueContainer?.querySelector("svg");

			if (overlay && !overlay.hasAttribute("data-listener-added")) {
				overlay.addEventListener("click", () => {
					popUp.style.display = "none";
				});
				overlay.setAttribute("data-listener-added", "true");
			}

			if (closeButton && !closeButton.hasAttribute("data-listener-added")) {
				closeButton.addEventListener("click", () => {
					popUp.style.display = "none";
				});
				closeButton.setAttribute("data-listener-added", "true");
			}

			if (copyButton && !copyButton.hasAttribute("data-listener-added")) {
				copyButton.style.cursor = "pointer";
				copyButton.style.transition =
					"background-color 0.2s ease, color 0.2s ease";
				
				const originalCuponText = cuponValueContainer?.textContent?.trim() || "";
				
				copyButton.addEventListener("click", (e) => {
					e.stopPropagation();
					navigator.clipboard.writeText(originalCuponText);

					const existingTooltip = cuponValueContainer?.querySelector(
						".sc-cupons-copy-tooltip",
					);

					let tooltip = existingTooltip;
					if (!tooltip && cuponValueContainer) {
						tooltip = document.createElement("span");
						tooltip.className = "sc-cupons-copy-tooltip";
						tooltip.textContent = "¡Copiado!";
						tooltip.style.cssText =
							"position:absolute; left:calc(100% + 10px); top:50%; background:#2b2b2b; color:#fff; padding:8px 12px; border-radius:8px; font-size:14px; font-weight:600; line-height:1; box-shadow:0 6px 18px rgba(0,0,0,.18); z-index:9999; opacity:0; transform:translate(6px, -50%); pointer-events:none; transition:opacity .2s ease, transform .2s ease; white-space:nowrap;";

						const tooltipArrow = document.createElement("span");
						tooltipArrow.style.cssText =
							"position:absolute; left:-6px; top:50%; transform:translateY(-50%); width:0; height:0; border-top:6px solid transparent; border-bottom:6px solid transparent; border-right:6px solid #2b2b2b;";
						tooltip.appendChild(tooltipArrow);

						const containerStyle = window.getComputedStyle(
							cuponValueContainer,
						);
						if (containerStyle.position === "static") {
							cuponValueContainer.style.position = "relative";
						}
						cuponValueContainer.appendChild(tooltip);
					}

					if (tooltip) {
						tooltip.style.opacity = "1";
						tooltip.style.transform = "translate(0, -50%)";
						window.clearTimeout(tooltip.hideTimeoutId);
						tooltip.hideTimeoutId = window.setTimeout(() => {
							tooltip.style.opacity = "0";
							tooltip.style.transform = "translate(6px, -50%)";
						}, 1200);
					}
				});

				copyButton.addEventListener("mouseenter", () => {
					copyButton.style.backgroundColor = "rgba(43, 43, 43, 0.15)";
				});

				copyButton.addEventListener("mouseleave", () => {
					copyButton.style.backgroundColor = "transparent";
					copyButton.style.color = "inherit";
				});
				copyButton.setAttribute("data-listener-added", "true");
			}
		});
	});
};

window.addEventListener("DOMContentLoaded", function () {
	const categorySelected = getInitialCategoryFilter();

	searchOffers(categorySelected || "", 1);

	searchButton.addEventListener("click", () => {
		activePagination = 1;
		searchOffers(categoriesSelect.value, 1);

		dataLayer.push({
			event: "click",
			name: "buscar_cupones",
			page: this.window.location.pathname,
			id: button.textContent,
		});
	});

	clearFilterLink.addEventListener("click", (e) => {
		e.preventDefault();
		activePagination = 1;
		categoriesSelect.value = "";
		searchOffers("", 1);
	});
});

const createPagination = () => {
	let result = "";
	let firstIndexActive = false;
	let prevIndexActive = false;
	let nextIndexActive = false;
	let lastIndexActive = false;

	if (numberOfPages > 2 && activePagination > 2) {
		result += `
            <a
                class="sc-pagination__container__pagination-numbers__numbers__firts-index"
            >
                1
            </a>
            <span class="sc-pagination__container__pagination-numbers__numbers__spread-points">
                ...
            </span>
            `;

		firstIndexActive = true;
	}

	if (activePagination > 1) {
		result += `
            <a
                class="sc-pagination__container__pagination-numbers__numbers__prev-index"
            >
                ${activePagination - 1}
            </a>
            `;
		prevIndexActive = true;
	}

	result += `
            <a class="sc-pagination__container__pagination-numbers__numbers__active-index">
                ${activePagination}
            </a>
        `;

	if (numberOfPages > activePagination) {
		result += `
            <a
                class="sc-pagination__container__pagination-numbers__numbers__next-index"
            >
                ${activePagination + 1}
            </a>
            `;
		nextIndexActive = true;
	}

	if (numberOfPages > activePagination + 1) {
		result += `
            <span class="sc-pagination__container__pagination-numbers__numbers__spread-points">
            ...
            </span>
            <span
                class="sc-pagination__container__pagination-numbers__numbers__last-index"
            >
                ${numberOfPages}
            </span>
        `;

		lastIndexActive = true;
	}

	result += `
        <span class="sc-pagination__container__pagination-numbers__numbers__pages-cuantity">
            ${activePagination} de ${numberOfPages}
        </span>
        `;

	if (paginationNumbers) {
		while (paginationNumbers.firstChild) {
			paginationNumbers.removeChild(paginationNumbers.firstChild);
		}
		paginationNumbers.insertAdjacentHTML("afterbegin", result);
	}

	addPaginationListeners({
		firstIndexActive,
		prevIndexActive,
		nextIndexActive,
		lastIndexActive,
	});
};

const addPaginationListeners = ({
	firstIndexActive,
	prevIndexActive,
	nextIndexActive,
	lastIndexActive,
}) => {
	if (firstIndexActive) {
		const firstIndex = document.querySelector(
			".sc-pagination__container__pagination-numbers__numbers__firts-index",
		);

		firstIndex.addEventListener("click", () => {
			activePagination = 1;
			searchOffers(currentFilter, activePagination, true);
		});
	}

	if (prevIndexActive) {
		const prevIndex = document.querySelector(
			".sc-pagination__container__pagination-numbers__numbers__prev-index",
		);

		prevIndex.addEventListener("click", () => {
			activePagination = activePagination - 1;
			searchOffers(currentFilter, activePagination, true);
		});
	}

	if (nextIndexActive) {
		const nextIndex = document.querySelector(
			".sc-pagination__container__pagination-numbers__numbers__next-index",
		);

		nextIndex.addEventListener("click", () => {
			activePagination = activePagination + 1;
			searchOffers(currentFilter, activePagination, true);
		});
	}

	if (lastIndexActive) {
		const lastIndex = document.querySelector(
			".sc-pagination__container__pagination-numbers__numbers__last-index",
		);

		lastIndex.addEventListener("click", () => {
			activePagination = Number(numberOfPages);
			searchOffers(currentFilter, activePagination, true);
		});
	}

	if (goToIndexArrow) {
		goToIndexArrow.addEventListener("click", () => {
			if (
				goToIndexInput.value <= numberOfPages &&
				goToIndexInput.value > 0 &&
				goToIndexInput.value !== activePagination
			) {
				activePagination = Number(goToIndexInput.value);
				searchOffers(currentFilter, activePagination, true);
			}
		});
	}
};

if (prevArrowNumber) {
	prevArrowNumber.addEventListener("click", () => {
		if (activePagination > 1) {
			activePagination = activePagination - 1;
			searchOffers(currentFilter, activePagination, true);
		}
	});
}

if (nextArrowNumber) {
	nextArrowNumber.addEventListener("click", () => {
		if (activePagination < numberOfPages) {
			activePagination = activePagination + 1;
			searchOffers(currentFilter, activePagination, true);
		}
	});
}
const addAnimation = () => {
	const cuponsGrid = document.querySelectorAll(
		".sc-cupons__grid > .card-item > .card__offer",
	);

	let options = {
		root: null,
		rootMargin: "0px",
		threshold: 0.0,
	};

	function handleGridWatcherEntry(entries, observer) {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				animateGrid(entry.target);
				observer.unobserve(entry.target);
			}
		});
	}

	const intersectionWathcer = () => {
		let observerStep = new IntersectionObserver(
			handleGridWatcherEntry,
			options,
		);

		cuponsGrid.forEach((grid) => {
			observerStep.observe(grid);
		});
	};

	intersectionWathcer();

	const animateGrid = (step) => {
		let style = window.getComputedStyle(step);
		let leftValue = style.getPropertyValue("left");

		if (leftValue.charAt(0) === "-") {
			anime({
				targets: step,
				left: "0px",
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 500,
				delay: 500,
			});
		} else {
			anime({
				targets: step,
				left: "0px",
				opacity: [0, 1],
				easing: "easeOutExpo",
				duration: 500,
				delay: 500,
			});
		}
	};
};

/* eslint-enable no-console */
